module.exports = __webpack_public_path__ + "img/activate_account.39b35cf2.svg";